import {EventTriggerConfig, TimeTriggerConfig, TriggerType} from './RoutineTypes';
import {RoutineFormState} from './useRoutineForm';

export function isTriggerComplete(formState: RoutineFormState): boolean {
  if (formState.triggerType == null) {
    return false;
  }
  if (formState.triggerType === TriggerType.TIME_BASED) {
    const config = formState.triggerConfig as Partial<TimeTriggerConfig>;
    const hasTime = (config.run_time ?? '') !== '';
    if (config.freq_type === 'weekly') {
      return (config.weekly_days ?? []).length > 0 && hasTime;
    }
    return hasTime;
  }
  const config = formState.triggerConfig as Partial<EventTriggerConfig>;
  const hasObjectType = (config.object_type ?? '') !== '';
  const validSchemaScope = config.schema_id == null || config.schema_id !== '';
  const validInstanceScope = config.object_ids == null || config.object_ids.length > 0;
  if (!hasObjectType || !validSchemaScope || !validInstanceScope) {
    return false;
  }
  const triggerKind = config.trigger_kind;
  if (triggerKind == null) {
    return false;
  }
  if (triggerKind === 'object_created') {
    return true;
  }
  const hasField = (config.field ?? '') !== '';
  const hasValues = (config.to_values ?? []).length > 0;
  return hasField && hasValues;
}

export function sanitizeTriggerConfig(
  triggerType: TriggerType,
  config: Partial<TimeTriggerConfig> | Partial<EventTriggerConfig>
): TimeTriggerConfig | EventTriggerConfig {
  if (triggerType === TriggerType.TIME_BASED) {
    const timeConfig = config as Partial<TimeTriggerConfig>;
    if (timeConfig.freq_type !== 'weekly') {
      const {weekly_days: _, ...rest} = timeConfig;
      return rest as unknown as TimeTriggerConfig;
    }
    return timeConfig as unknown as TimeTriggerConfig;
  }
  return config as EventTriggerConfig;
}

export function canSaveRoutine(
  formState: RoutineFormState,
  isEdit: boolean,
  isDirty: boolean,
  isSaving: boolean
): boolean {
  const hasRequiredFields =
    formState.name.trim() !== '' && formState.prompt.trim() !== '' && isTriggerComplete(formState);
  return isEdit ? isDirty && !isSaving && hasRequiredFields : hasRequiredFields && !isSaving;
}
